import { makeLink } from "./links";
import ENCopy from "./copy.en";
import { labelOptions } from "./consoleOptions";
import { urls } from "./urls";
import { get } from "svelte/store";

// Spanish
const minimumAge = 18;

const copy = (): ReturnType<typeof ENCopy> => ({
  urls,
  prizeNames: {
    operatorSkin: "SKIN DE OPERADOR",
    operatorSkinSplit: "SKIN DE <br> OPERADOR",
    operatorSkinS: "SKIN DE <br> OPERADOR",
    codPoints: "PUNTOS <i>CALL OF DUTY</i>",
    emblem: "EMBLEMA",
    charm: "CHARM",
    callingCard: "CALLING CARD",
    plus: "¡ADEMÁS, ",
    youCanWin: "PUEDES GANAR PASES PARA BATALLAS Y PUNTOS <i>CALL OF DUTY</i>!",
    youCanWinSplit: "PUEDES GANAR <br> PASES PARA BATALLAS <br> Y PUNTOS <i>CALL OF DUTY</i>!",
    firstPurchase: "Primera Compra:",
    secondPurchase: "Segunda Compra:",
    thirdPurchase: "Tercera Compra:",
    oneInGameEmblem: "(1) Emblema en el Juego",
    oneInGameCharm: "(1) Charm en el Juego",
    oneInGameCallingCard: "(1) Calling Card en el Juego",
    oneInGameOperatorSkin: "(1) Skin de Operador en el Juego"
  },
  error: {
    generic: {
      title: "ERROR",
      subtitle: "Ocurrió un error desconocido.",
      retryButton: "Intentar de nuevo"
    },
    invalidEntry: {
      title: "ERROR",
      subtitle: "EL CÓDIGO O RECIBO QUE INGRESÓ NO ES VÁLIDO. POR FAVOR, INTENTE DE NUEVO Y ASEGÚRESE DE SEGUIR LAS DIRECTRICES.",
      info: `Si aún tiene problemas y cree que su participación debería ser elegible, comuníquese con ${makeLink(get(urls).contactUs, "Atención al cliente")}.`,
      retryButton: "Intentar de nuevo"
    },
    unlucky: {
      title: "ERROR",
      subtitle: "No pudimos desbloquear tu recompensa debido a una de las siguientes razones:",
      renderActivisionErrorDetails: true,
      retryButton: "Intentar de nuevo"
    },
    unableToValidateReceipt: {
      title: "ERROR",
      subtitle: "NO PUDIMOS VALIDAR TU ENTRADA EN ESTE MOMENTO. POR FAVOR, INTENTA DE NUEVO MÁS TARDE.",
      retryButton: "Intentar de nuevo"
    },
    underage: {
      title: "ERROR",
      subtitle: `Debes tener al menos ${minimumAge} años para participar.`,
    },
    alreadyParticipatedToday: {
      title: "ERROR",
      subtitle: "Ya has enviado una entrada hoy. Por favor, vuelve mañana."
    },
    unsupportedCountry: {
      title: "ERROR",
      subtitle: "Esta promoción no está disponible en tu país.",
      info: `Esta promoción está disponible solo para residentes legales de los Estados Unidos, Canadá (excluyendo Quebec) y México. Por favor, revisa más tarde para ver si hay promociones futuras que puedan estar disponibles en tu región.`,
    },
    campaignNotSupported: {
      title: "ERROR",
      subtitle: "Esta promoción no está disponible en tu país.",
      info: `Haz clic abajo para visitar la campaña compatible.`,
      retryButton: "Participar"
    }
  },
  common: {
    unlock: "DESBLOQUEAR",
    dual2xp: "DUAL 2XP",
  },
  header: {
    menus: {
      orderFromLittleCaesars: "ORDENE DESE LITTLE CAESARS<sup>®</sup>",
      chooseYourLanguage: "ELIJA SU IDIOMA"
    },
    ariaLabels: {
      logo: "Logo de Little Caesars",
      menuButton: "Abrir menú de navegación"
    }
  },
  countrySelector: {
    title: "SELECCIONE SU PAÍS",
    placeholder: "Elegir país",
    confirmButton: "CONFIRMAR"
  },
  teaser: {
    title: "INFORME",
    subtitle: "ESTA PROMOCIÓN LLEGARÁ PRONTO. <br> VUELVA A CONSULTAR EL 3 DE NOVIEMBRE."
  },
  over: {
    title: "MISIÓN <br> COMPLETADA",
    subtitle: "ESTA PROMOCIÓN HA TERMINADO."
  },
  prizes: {
    mobileTitleClasses: "text-[50px] mobileS:text-[60px] mobile:text-[90px] tablet:text-[84px]",
    title: "RECOMPENSAS <br> & PREMIOS",
    subtitle: "¡EXPLORA LO QUE PUEDES GANAR!"
  },
  activisionErrorDetails: {
    reasons: [
      "Has alcanzado el límite de 40 horas de XP máximo en contenido de bonificación en tu cuenta. Una vez que se alcanza este estado, no puedes recibir fichas de XP adicionales.",
      "Tu cuenta de Activision no está vinculada a una cuenta de juego. Asegúrate de que tu cuenta de Activision esté vinculada a una cuenta de juego para canjear la recompensa."
    ],
    contactSupport: `Si ninguna de las anteriores se aplica, comunícate con ${makeLink(get(urls).activisionSupport, "Soporte Activision")} para obtener ayuda adicional.`
  },
  registration: {
    title: "LAS RECOMPENSAS <br> EN EL JUEGO <br> ESTÁN DE VUELTA",
    subtitle: "¡REGÍSTRATE AHORA!",
    limitedToThreeTotalQualifyingPurchases: "(Limitado a TRES COMPRAS calificadas en total)",
    requiredField: "Campo Requerido",
    selectCountry: "Por favor elige el país en el que vives:",
    consolePreference: "Consola de Videojuegos Preferida para&nbsp;<i>Call of Duty: Black Ops 7</i>",
    consolePreferencePlaceholder: "Consola de Videojuegos Preferida para Call of Duty: Black Ops 7",
    consolePreferenceOptions: labelOptions({
      xbox: "Xbox®",
      playstation: "PlayStation®",
      battleNet: "Battle.net",
      steam: "Steam®",
      microsoftStore: "Xbox® on PC"
    }),
    notGuaranteed: "Call of Duty: Black Ops 7 premio no garantizado.",
    firstNameLabel: "Nombre",
    lastNameLabel: "Apellido",
    emailLabel: "Correo Electrónico",
    dobLabel: "Fecha de Nacimiento",
    confirmEmailLabel: "Confirma correo electrónico",
    skillLabel: "Resolver:",
    submitButton: "ENVIAR",
    minimumAge,
    ariaLabels: {
      checkboxDescribedBy: "interruptor de casilla de verificación",
      submitButton: "Enviar formulario de registro"
    },
    validations: {
      invalidSkillAnswer: "Respuesta inválida",
      invalidConsoleOption: "Por favor elige una consola de videojuegos",
      firstNameEmpty: "Ingrese su nombre de pila",
      firstNameInvalid: "Su nombre de pila es demasiado corto",
      firstNameContainsIllegalCharacters: "Su nombre de pila contiene caracteres no permitidos",
      lastNameEmpty: "Ingrese su apellido",
      lastNameInvalid: "Su apellido es demasiado corto",
      lastNameContainsIllegalCharacters: "Su apellido contiene caracteres no permitidos",
      emailEmpty: "Ingrese su dirección de correo electrónico",
      emailInvalid: "Ingrese una dirección de correo electrónico válida",
      dobInvalid: "Ingrese una fecha de nacimiento válida",
      dobUnderage: `Debes tener al menos ${minimumAge} años para participar`,
      mandatoryCheckbox: "Este cuadro de verificación es obligatorio para continuar"
    }
  },
  homepage: {
    titleTextClasses: "text-[50px] mobileS:text-[60px] mobile:text-[88px] tablet:text-[74px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]",
    for: "para",
    blackOps6: "Call of Duty® : Black Ops 7",
    note: `con cualquier compra válida<span class="reg">*</span> en Little Caesars<span class="reg">®</span>.`,
    bonus: "PODRÁS GANAR RECOMPENSAS EXTRA EN EL <br> JUEGO COMO PASES PARA BATALLAS <br> Y PUNTOS <i>CALL OF DUTY</i>!",
    entry: {
      label: "SU CORREO ELECTRÓNICO",
      button: "DESBLOQUEAR RECOMPENSAS",
      info: "Por favor ingresa tu dirección de correo electrónico con tu cuenta Activision.",
      rules: `Consulta el ${makeLink(get(urls).officialRules, "Reglamento Oficial")} para saber cómo ingresar sin una compra.`
    },
    rewardsButton: "VER RECOMPENSAS"
  },
  purchaseSelection: {
    titleTextClasses: "text-[50px] mobileS:text-[60px] mobile:text-[88px] tablet:text-[74px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]",
    subtitle: "SELECCIONA CÓMO TE GUSTARÍA INTRODUCIR TU COMPRA",
    limits: "Máximo un código/recibo por día",
    or: "O",
    action: "INTRODUCIR O CARGAR",
    actionCodeSmall: "Introduce",
    actionCode: "INTRODUCE TU CÓDIGO DE RECIBO",
    actionCodeDescription: "Si realizaste una compra en el sitio web, app o restaurante y tu recibo tiene un código único, introduce ese código aquí.",
    actionUploadSmall: "Carga",
    actionUpload: "CARGA TU RECIBO DE RESTAURANTE",
    actionUploadDescription: "Si realizaste una compra en el restaurante y tu recibo impreso no tiene un código, toma un foto clara del recibo completo y cárgalo aquí.",
    checkRules: `Consulta el ${makeLink(get(urls).officialRules, "Reglamento Oficial")} para saber cómo ingresar sin una compra.`
  },
  code: {
    title: `HAS OBTENIDO <br class="hidden tablet:block"> UN CÓDIGO`,
    subtitle: "FAVOR DE INTRODUCIR EL CÓDIGO ÚNICO QUE APARECE EN EL CORREO ELECTRÓNICO DE CONFIRMACIÓN DEL PEDIDO O EN EL RECIBO DE LITTLE CAESARS",
    invalidCode: "Código inválido",
    failedToSaveCode: "No se pudo guardar el código. Por favor, inténtelo de nuevo.",
    label: "INTRODUCE EL DÍGITO 7-DEL CÓDIGO",
    button: "ENVIAR",
    findCode: "Encuentra tu código en el correo electrónico de confirmación del pedido en línea o en tu",
    findCodeLink: "recibo del restaurante",
    limits: "Máximo un envío de código por día.",
    noCodeTryReceipt: {
      initial: "¿No tienes código?",
      linked: "Haz clic aquí para cargar el recibo"
    },
    support: {
      haveCode: "¿Tienes un código de atención al cliente?",
      link: "Haz clic aquí."
    }
  },
  receipt: {
    titleTextClasses: "text-[50px] mobileS:text-[62px] mobile:text-[84px] tablet:text-[84px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]",
    title: "COMPARTE TU INTEL",
    subtitle: `CARGA UNA FOTO DE TU RECIBO DEL <br class="block mobile:hidden"> RESTAURANTE LITTLE CAESARS<span class="reg text-[0.7em] align-top">®</span> AQUÍ`,
    noReceiptTryCode: {
      initial: "Si tienes un código en la parte de debajo de tu recibo,",
      linked: "haz clic aquí para ingresarlo"
    },
    info: `Las cargas de los recibos con códigos serán rechazadas. <br class="block mobile:hidden"> Máximo un envío de código por día.`,
    guidelinesTitle: "GUÍA PARA CARGAR RECIBOS",
    guidelineIntro1: "Por favor asegúrate de cargar una foto clara del",
    guidelineIntroLink: "recibo completo",
    guidelineIntro2: "que contenga la siguiente información:",
    guidelinesList: [
      "ID único (número de transacción)",
      "Ubicación de Little Caesars (debe ser México o Canadá, excluyendo Quebec)",
      "Fecha de compra (debe ser entre el 03/11/25 y el 31/12/25)",
      "Subtotal de la orden (debe cumplir el requisito de compra válida*)",
      "Favor de incluir únicamente un recibo por foto"
    ],
    uploadFromDevice: "CARGAR DESDE TU DISPOSITIVO",
    dragFileToUpload: "ARRASTRA PARA CARGAR",
    chooseFile: "ELIGE UN ARCHIVO",
    continueButton: "SIGUIENTE",
    rejectedFile: "Tu archivo fue rechazado por el servidor. Asegúrate de que sea un archivo JPEG o PNG válido, que el tamaño del archivo sea inferior a 6MB y que siga lo guía.",
    receiptData: {
      completeReceiptInfo: "Completa la información de tu recibo",
      orderNumber: "Número de Orden",
      orderNumberPlaceholder: "Ingrese el número de orden",
      orderDate: "Fecha de Compra",
      location: "Ubicación de Little Caesars",
      locationPlaceholder: "Buscar ubicación de la tienda",
      submitReceipt: "Enviar Recibo",
      validations: {
        orderNumberRequired: "El número de orden es requerido",
        orderNumberInvalid: "El número de orden debe ser un número",
        orderDateRequired: "La fecha de compra es requerida",
        orderDateTooRecent: "La fecha de compra es muy reciente. Inténtalo de nuevo más tarde.",
        orderDateInFuture: "La fecha de compra no puede ser en el futuro",
        orderDateTooOld: "Los recibos deben ser posteriores al 3 de noviembre",
        locationRequired: "La ubicación es requerida"
      },
      codeGenerated: {
        message: `Se generó un código para este recibo. Por favor revisa tu correo electrónico y usa el código para canjear tu premio. <br class="hidden tablet:block"> Si no lo encuentras, por favor contacta al servicio al cliente de Little Caesars en ${makeLink(get(urls).contactLittleCaesars, "Contáctanos - Little Caesars®")}.`,
        linkText: "Haz clic aquí para ingresar tu código"
      },
      saveFailedErrorMessage: "Error al guardar la información del recibo. Por favor, inténtalo de nuevo."
    }
  },
  rateLimited: {
    title: "Límite de Velocidad",
    message: "Has realizado demasiados intentos. Por favor espera un momento antes de intentar de nuevo.",
    ariaCloseButton: "Cerrar modal de límite de velocidad",
    ariaModalDescription: "Modal de límite de velocidad"
  },
  verifyModal: {
    closeButtonAriaLabel: "Cerrar modal de verificación",
    modalAriaDescription: "Verifica tu número de teléfono o correo electrónico",
    title: "Verifica tu número",
    smsMessage: "Por favor ingresa el código de 6 dígitos que fue enviado a tu número que termina en {phoneNumber}.",
    emailMessage: "Por favor ingresa el código de 6 dígitos que fue enviado a tu correo electrónico.",
    toggleToEmail: "¿Prefieres verificar por correo electrónico?",
    toggleToSms: "¿Prefieres verificar por mensaje de texto?",
    toggleLink: "Haz clic aquí",
    verifyButton: "Verificar",
    countdownMessage: "Solicitar nuevo código en {countdown} segundos",
    requestNewCode: "¿No recibiste un código? Haz clic aquí para solicitar uno nuevo.",
    errors: {
      requestFailed: "Error al solicitar nuevo código de verificación.",
      toggleChannelFailed: "Error al cambiar canal.",
      verificationFailed: "La verificación falló. Por favor intenta de nuevo.",
      verificationFinishFailed: "Error al finalizar verificación... {errorMessage}",
      multipleCallOfDutyIdentities: "El correo electrónico que estás intentando usar ya está vinculado a una cuenta de <i>Call of Duty</i> diferente."
    }
  },
  reviewReceipt: {
    titleTextClasses: "text-[50px] mobileS:text-[62px] mobile:text-[84px] tablet:text-[84px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]",
    title: "REVISA TU INTEL COMPARTIDO",
    subtitle: "CONFIRMA LA CARGA DE TU RECIBO.",
    flipPhoto: "Voltear foto",
    info: "Vista previa de tu envío.  Si necesitas actualizar algo o quisieras enviar una nueva entrada, da clic ATRÁS. De lo contrario, da clic en ENVIAR para completar tu entrada.",
    limits: "Máximo un envío de recibo por día.",
    receiptPreview: "VISTA PREVIA DEL RECIBO",
    backButton: "ATRÁS",
    submitButton: "ENVIAR"
  },
  thankYou: {
    title: "BIENVENIDO <br> A BORDO",
    subtitle: `GRACIAS POR UNIR FUERZAS CON NOSOTROS. <br class="hidden tablet:block"> HAS DESBLOQUEADO:`,
    prizeInfo: "Por favor revisa tu correo electrónico para más información sobre tu recompensa.",
    orderAgain: "¡ORDENA DE NUEVO MAÑANA <br> Y DESBLOQUEA MÁS RECOMPENSAS!",
  },
  footer: {
    navItems: {
      rewardsAndPrizes: "Recompensas & Premios",
      officialRules: "Reglamento Oficial",
      faq: "Preguntas frecuentes",
      termsOfService: "Términos de Servicio",
      privacyPolicy: "Política de Privacidad",
      usStatePrivacyPolicy: "Política de Privacidad en EUA",
      contactUs: "Contáctanos",
      nonParticipatingStores: "Tiendas no participantes"
    },
    ariaLabels: {
      navigation: {
        rewardsAndPrizes: "Recompensas & Premios se abre en una nueva pestaña",
        officialRules: "Reglamento Oficial se abre en una nueva pestaña",
        faq: "Preguntas frecuentes se abre en una nueva pestaña",
        termsOfService: "Términos de Servicio se abre en una nueva pestaña",
        privacyPolicy: "Política de Privacidad se abre en una nueva pestaña",
        usStatePrivacyPolicy: "Política de Privacidad en EUA se abre en una nueva pestaña",
        contactUs: "Contáctanos se abre en una nueva pestaña",
        nonParticipatingStores: "Tiendas no participantes se abre en una nueva pestaña"
      }
    },
    info: `
      NO ES NECESARIO COMPRAR. Nulo Donde Esté Prohibido. Residentes de 50 Estados Unidos y DC, Canadá (excl. Quebec) y México, deben ser mayores de edad.
      Termina el 31/12/25 (códigos deben ser ingresados antes del 31/01/2026). 19,653 premios disponibles al inicio de la promoción (VMR de $4.99 a $99.99 USD).
      Límite de 1 HORA de TOKEN 2XP por día; 40 HORAS en total. Se aplica a todas las promociones 2XP para <i>Call of Duty: Black Ops 7</i>
      (no limitado a esta promoción). Las probabilidades dependen del momento de participación y números. Se requieren habilidades matemáticas en Canadá y México.
      ${makeLink(get(urls).officialRules, "Consulta el reglamento oficial")}. Patrocinador: Little Caesar Enterprises, Inc.
    `,
    copyright: `
      Clasificación ESRB: MATURE. Visite ${makeLink("https://www.esrb.org", "www.esrb.org")}. ©/™/® 2025 Activision Publishing, Inc.
    `,
    pattern: "/assets/images/esrb-es.svg?v=202511131232"
  }
});

export default copy;
